import React from 'react'
import _ from 'lodash'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

class PreviewData extends React.Component {

  render() {
    const { item, styles, handleChange, dropzoneStyles, disableFields, ChangePreviewImages, client, items, handleItemOptionSelect, itemPreview } = this.props
    const thisProductId = item.productId
    const thisProductItems = items.results.filter(productItem => productItem.productId === thisProductId)
    return (
      <div>
        <h2>Preview Data</h2>
        <div className="content">
          <h3>Custom Text Fields (Vertical)</h3>
          <SelectField
              onChange={(event, index, value) => handleItemOptionSelect(event, index, value)}
              floatingLabelText="Copy Settings From:"
              name="productItem"
              floatingLabelStyle={styles.floatingLabelStyle}
            >
              {thisProductItems.map((productItem, i) =>{
                return <MenuItem  key={i} value={productItem} primaryText={productItem.name} />
              })}
            </SelectField>
            <br /> <br />
          <TextField
            floatingLabelText="Vertical Preview Text X"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={itemPreview.portrait[0].textX}
            type="number"
            name={`portrait[0].textX`}
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Text Y"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={itemPreview.portrait[0].textY}
            type="number"
            name={`portrait[0].textY`}
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Text Width"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={itemPreview.portrait[0].textWidth}
            type="number"
            name={`portrait[0].textWidth`}
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Text Height"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={itemPreview.portrait[0].textHeight}
            type="number"
            name={`portrait[0].textHeight`}
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Text Font Color"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={itemPreview.portrait[0].fontColor}
            name={`portrait[0].fontColor`}
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          {itemPreview.portrait.map((portrait, index) => {
            return (
              <div>
                <br />
                {itemPreview.numPhotos < 2 ?
                  <h3 style={{ fontSize: '18px' }}>Vertical Settings</h3>
                  : <h3 style={{ fontSize: '18px' }}>Photo - {portrait.index}</h3>
                }
                <TextField
                  floatingLabelText="Vertical Background Image Url"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.img}
                  name={`portrait[${index}].img`}
                  onChange={!disableFields ? handleChange : ''}
                  style={styles.inputStyleLarge}
                />
                <button
                  className="filestack-button"
                  onClick={(e) => {
                    e.preventDefault;
                    return client.picker({
                      uploadInBackground: false,
                      onUploadDone: ((res) => {
                        console.log('RES FROM FILESTACK', res);
                        const targetName = `portrait[${index}]img`
                        const targetValue = res.filesUploaded[0].url
                        ChangePreviewImages(targetName, targetValue)
                      })
                    }).open()
                  }}
                  style={dropzoneStyles}>
                  <p className="filestack-uplaod">Upload Vertical Background Image</p>
                </button>
                <br />
                <div style={{ position: 'relative', width: '870px', height: '607px' }}>
                  <div style={{
                    width: `${portrait.textWidth}px`,
                    height: `${portrait.textHeight}px`,
                    position: 'absolute',
                    verticalAlign: 'middle',
                    zIndex: 5,
                    top: `${portrait.textY}px`,
                    left: `${portrait.textX}px`,
                    border: '1px solid #ffc107',
                    backgroundColor: '#ffc1072e'
                  }}></div>
                  <img style={{ width: '870px', height: '607px', verticalAlign: 'middle', border: '0px', position: 'relative' }}
                    src={portrait.img} />
                  <div style={{
                    width: `${portrait.width}px`,
                    height: `${portrait.height}px`,
                    position: 'absolute',
                    verticalAlign: 'middle',
                    zIndex: 5,
                    top: `${portrait.y}px`,
                    left: `${portrait.x}px`,
                    border: '1px solid #0062cc',
                    backgroundColor: 'rgba(0, 98, 204, .28)'
                  }}>
                  </div>
                </div>
                <br />
                <TextField
                  floatingLabelText="Vertical Preview Img X Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.x}
                  type="number"
                  name={`portrait[${index}].x`}
                  onChange={!disableFields ? handleChange : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Y Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.y}
                  type="number"
                  name={`portrait[${index}].y`}
                  onChange={!disableFields ? handleChange : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Z"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.z}
                  type="number"
                  name={`portrait[${index}].z`}
                  onChange={!disableFields ? handleChange : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.width}
                  type="number"
                  name={`portrait[${index}].width`}
                  onChange={!disableFields ? handleChange : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.height}
                  type="number"
                  name={`portrait[${index}].height`}
                  onChange={!disableFields ? handleChange : ''}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Angle"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.angle || 0}
                  type="number"
                  name={`portrait[${index}].angle`}
                  onChange={!disableFields ? handleChange : ''}
                  style={styles.inputStyle}
                />
                <br/><br/>
                <TextField
                  floatingLabelText="Zoomed Overlay"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.zoomedOverlay}
                  name={`portrait[${index}].zoomedOverlay`}
                  onChange={!disableFields ? handleChange : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyleLarge}
                />
                <button
                  className="filestack-button"
                  onClick={(e) => {
                    e.preventDefault;
                    return client.picker({
                      uploadInBackground: false,
                      onUploadDone: ((res) => {
                        console.log('RES FROM FILESTACK', res);
                        const targetName = `portrait[${index}]zoomedOverlay`
                        const targetValue = res.filesUploaded[0].url
                        ChangePreviewImages(targetName, targetValue)
                      })
                    }).open()
                  }}
                  style={dropzoneStyles}>
                  <p className="filestack-uplaod">Upload Vertical Zoomed Overlay Image</p>
                </button>
                <br />
                <div style={{ position: 'relative', width: '870px', height: '607px' }}>
                  <img style={{ width: '870px', height: '607px', verticalAlign: 'middle', border: '0px', position: 'relative' }}
                    src={portrait.zoomedOverlay} />
                  <div style={{
                    width: `${portrait.zoomedWidth}px`,
                    height: `${portrait.zoomedHeight}px`,
                    position: 'absolute',
                    verticalAlign: 'middle',
                    zIndex: 5,
                    top: `${portrait.zoomedY}px`,
                    left: `${portrait.zoomedX}px`,
                    border: '1px solid #0062cc',
                    backgroundColor: 'rgba(0, 98, 204, .28)'
                  }}>
                  </div>
                </div>
                <br />
                <TextField
                  floatingLabelText="Zoomed X"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.zoomedX}
                  type="number"
                  name={`portrait[${index}].zoomedX`}
                  onChange={!disableFields ? handleChange : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Y"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.zoomedY}
                  type="number"
                  name={`portrait[${index}].zoomedY`}
                  onChange={!disableFields ? handleChange : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.zoomedWidth}
                  type="number"
                  name={`portrait[${index}].zoomedWidth`}
                  onChange={!disableFields ? handleChange : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  value={portrait.zoomedHeight}
                  type="number"
                  name={`portrait[${index}].zoomedHeight`}
                  onChange={!disableFields ? handleChange : ''}
                  floatingLabelFixed={true}
                  style={styles.inputStyle}
                />
              </div>)
          })}
          <br />
          <br />
          {itemPreview.numPhotos < 2 ?
            <div>
              {itemPreview.landscape.map((landscape, index) => {
                return (
                  <div>
                    <h3 style={{ fontSize: '18px' }}>Horizontal Settings</h3>
                    <TextField
                      floatingLabelText="Horizontal Background Image Url"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      floatingLabelFixed={true}
                      value={landscape.img}
                      name={`landscape[${index}].img`}
                      onChange={!disableFields ? handleChange : ''}
                      style={styles.inputStyle}
                    />
                       <button
                  className="filestack-button"
                  onClick={(e) => {
                    e.preventDefault;
                    return client.picker({
                      uploadInBackground: false,
                      onUploadDone: ((res) => {
                        console.log('RES FROM FILESTACK', res);
                        const targetName = `landscape[${index}].img`
                        const targetValue = res.filesUploaded[0].url
                        ChangePreviewImages(targetName, targetValue)
                      })
                    }).open()
                  }}
                  style={dropzoneStyles}>
                  <p className="filestack-uplaod">Upload Horizontal Background Image</p>
                  </button>
                    <br />
                    <div style={{ position: 'relative', width: '870px', height: '607px' }}>
                      <img style={{ width: '870px', height: '607px', verticalAlign: 'middle', border: '0px', position: 'relative' }}
                        src={landscape.img} />
                      <div style={{
                        width: `${landscape.width}px`,
                        height: `${landscape.height}px`,
                        position: 'absolute',
                        verticalAlign: 'middle',
                        zIndex: 5,
                        top: `${landscape.y}px`,
                        left: `${landscape.x}px`,
                        border: '1px solid #0062cc',
                        backgroundColor: 'rgba(0, 98, 204, .28)'
                      }}>
                      </div>
                    </div>
                    <br />
                    <TextField
                      floatingLabelText="Horizontal Preview Img X Position"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      floatingLabelFixed={true}
                      value={landscape.x}
                      type="number"
                      name={`landscape[${index}].x`}
                      onChange={!disableFields ? handleChange : ''}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Horizontal Preview Img Y Position"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      floatingLabelFixed={true}
                      value={landscape.y}
                      type="number"
                      name={`landscape[${index}].y`}
                      onChange={!disableFields ? handleChange : ''}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Z"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.z}
                      type="number"
                      name={`landscape[${index}].z`}
                      onChange={!disableFields ? handleChange : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Horizontal Preview Img Width"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      floatingLabelFixed={true}
                      value={landscape.width}
                      type="number"
                      name={`landscape[${index}].width`}
                      onChange={!disableFields ? handleChange : ''}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Horizontal Preview Img Height"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      floatingLabelFixed={true}
                      value={landscape.height}
                      type="number"
                      name={`landscape[${index}].height`}
                      onChange={!disableFields ? handleChange : ''}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Horizontal Preview Img Angle"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      floatingLabelFixed={true}
                      value={landscape.angle || 0}
                      type="number"
                      name={`landscape[${index}].angle`}
                      onChange={!disableFields ? handleChange : ''}
                      style={styles.inputStyle}
                    />
                    <br />
                    <TextField
                      floatingLabelText="Zoomed Overlay"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.zoomedOverlay}
                      name={`landscape[${index}].zoomedOverlay`}
                      onChange={!disableFields ? handleChange : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                       <button
                  className="filestack-button"
                  onClick={(e) => {
                    e.preventDefault;
                    return client.picker({
                      uploadInBackground: false,
                      onUploadDone: ((res) => {
                        console.log('RES FROM FILESTACK', res);
                        const targetName = `landscape[${index}].zoomedOverlay`
                        const targetValue = res.filesUploaded[0].url
                        ChangePreviewImages(targetName, targetValue)
                      })
                    }).open()
                  }}
                  style={dropzoneStyles}>
                  <p className="filestack-uplaod">Upload Horizontal Zoomed Overlay Image</p>
                  </button>
                    <br />
                    <div style={{ position: 'relative', width: '870px', height: '607px' }}>
                      <img style={{ width: '870px', height: '607px', verticalAlign: 'middle', border: '0px', position: 'relative' }}
                        src={landscape.zoomedOverlay} />
                      <div style={{
                        width: `${landscape.zoomedWidth}px`,
                        height: `${landscape.zoomedHeight}px`,
                        position: 'absolute',
                        verticalAlign: 'middle',
                        zIndex: 5,
                        top: `${landscape.zoomedY}px`,
                        left: `${landscape.zoomedX}px`,
                        border: '1px solid #0062cc',
                        backgroundColor: 'rgba(0, 98, 204, .28)'
                      }}>
                      </div>
                    </div>
                    <br />
                    <TextField
                      floatingLabelText="Zoomed X"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.zoomedX}
                      type="number"
                      name={`landscape[${index}].zoomedX`}
                      onChange={!disableFields ? handleChange : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Zoomed Y"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.zoomedY}
                      type="number"
                      name={`landscape[${index}].zoomedY`}
                      onChange={!disableFields ? handleChange : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Zoomed Width"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.zoomedWidth}
                      type="number"
                      name={`landscape[${index}].zoomedWidth`}
                      onChange={!disableFields ? handleChange : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <TextField
                      floatingLabelText="Zoomed Height"
                      floatingLabelStyle={styles.floatingLabelStyle}
                      value={landscape.zoomedHeight}
                      type="number"
                      name={`landscape[${index}].zoomedHeight`}
                      onChange={!disableFields ? handleChange : ''}
                      floatingLabelFixed={true}
                      style={styles.inputStyle}
                    />
                    <br />
                  </div>)
              })}
            </div>
            : null}
          <br />
        </div>
      </div>
    )
  }
}
export default PreviewData


// WEBPACK FOOTER //
// ./src/components/items/Common/PreviewData.js